import { get } from 'lodash-es'

const LOCALE_TRANS = {
  en: 'en-GB',
}

export const getLocale = shortLocale => {
  return get(LOCALE_TRANS, shortLocale, shortLocale)
}
